// Main service categories
export const serviceCategories = [
  {
    id: "blockchain",
    icon: "Database",
    translations: {
      en: {
        title: "AI in Web3 & Blockchain",
        description:
          "Integrating AI into decentralized systems, from intelligent portfolio management to smart contract analytics.",
        metaDescription:
          "Expert blockchain development services including smart contracts, DeFi solutions, NFT platforms, and Web3 integration for businesses and enterprises.",
        keywords:
          "blockchain development, smart contracts, DeFi, NFT, Web3, Ethereum, Solana, decentralized applications",
      },
      fr: {
        title: "Développement Blockchain",
        description:
          "Solutions blockchain personnalisées, contrats intelligents et applications décentralisées pour les entreprises.",
        metaDescription:
          "Services experts de développement blockchain comprenant des contrats intelligents, des solutions DeFi, des plateformes NFT et l'intégration Web3 pour les entreprises.",
        keywords:
          "développement blockchain, contrats intelligents, DeFi, NFT, Web3, Ethereum, Solana, applications décentralisées",
      },
      de: {
        title: "Blockchain-Entwicklung",
        description:
          "Maßgeschneiderte Blockchain-Lösungen, Smart Contracts und dezentrale Anwendungen für Unternehmen.",
        metaDescription:
          "Experten-Blockchain-Entwicklungsdienste einschließlich Smart Contracts, DeFi-Lösungen, NFT-Plattformen und Web3-Integration für Unternehmen.",
        keywords: "Blockchain-Entwicklung, Smart Contracts, DeFi, NFT, Web3, Ethereum, Solana, dezentrale Anwendungen",
      },
      es: {
        title: "Desarrollo Blockchain",
        description:
          "Soluciones blockchain personalizadas, contratos inteligentes y aplicaciones descentralizadas para empresas.",
        metaDescription:
          "Servicios expertos de desarrollo blockchain que incluyen contratos inteligentes, soluciones DeFi, plataformas NFT e integración Web3 para empresas.",
        keywords:
          "desarrollo blockchain, contratos inteligentes, DeFi, NFT, Web3, Ethereum, Solana, aplicaciones descentralizadas",
      },
    },
  },
  {
    id: "genai",
    icon: "Brain",
    translations: {
      en: {
        title: "Custom AI Systems",
        description:
          "Custom AI assistants, LLM integration, computer vision applications, and natural language processing solutions.",
        metaDescription:
          "Advanced generative AI solutions including custom AI assistants, LLM integration, computer vision applications, and natural language processing for businesses.",
        keywords:
          "generative AI, AI assistants, LLM integration, computer vision, NLP, machine learning, AI development, GPT",
      },
      fr: {
        title: "Solutions GenAI",
        description:
          "Assistants IA personnalisés, intégration LLM, applications de vision par ordinateur et solutions de traitement du langage naturel.",
        metaDescription:
          "Solutions avancées d'IA générative comprenant des assistants IA personnalisés, l'intégration LLM, des applications de vision par ordinateur et le traitement du langage naturel pour les entreprises.",
        keywords:
          "IA générative, assistants IA, intégration LLM, vision par ordinateur, NLP, apprentissage automatique, développement IA, GPT",
      },
      de: {
        title: "GenAI-Lösungen",
        description:
          "Maßgeschneiderte KI-Assistenten, LLM-Integration, Computer-Vision-Anwendungen und Lösungen für die Verarbeitung natürlicher Sprache.",
        metaDescription:
          "Fortschrittliche generative KI-Lösungen einschließlich maßgeschneiderter KI-Assistenten, LLM-Integration, Computer-Vision-Anwendungen und Verarbeitung natürlicher Sprache für Unternehmen.",
        keywords:
          "generative KI, KI-Assistenten, LLM-Integration, Computer Vision, NLP, maschinelles Lernen, KI-Entwicklung, GPT",
      },
      es: {
        title: "Soluciones GenAI",
        description:
          "Asistentes de IA personalizados, integración de LLM, aplicaciones de visión por computadora y soluciones de procesamiento de lenguaje natural.",
        metaDescription:
          "Soluciones avanzadas de IA generativa que incluyen asistentes de IA personalizados, integración de LLM, aplicaciones de visión por computadora y procesamiento de lenguaje natural para empresas.",
        keywords:
          "IA generativa, asistentes de IA, integración de LLM, visión por computadora, NLP, aprendizaje automático, desarrollo de IA, GPT",
      },
    },
  },
  {
    id: "development",
    icon: "Code",
    translations: {
      en: {
        title: "AI Integration Development",
        description: "End-to-end web and mobile applications powered by integrated AI workflows.",
        metaDescription:
          "Professional full stack development services including frontend, backend, mobile app development, and DevOps for businesses of all sizes.",
        keywords:
          "full stack development, web development, mobile app development, React, Next.js, Node.js, TypeScript, DevOps",
      },
      fr: {
        title: "Développement Full Stack",
        description:
          "Développement d'applications web et mobiles de bout en bout avec des frameworks et technologies modernes.",
        metaDescription:
          "Services professionnels de développement full stack comprenant le développement frontend, backend, d'applications mobiles et DevOps pour les entreprises de toutes tailles.",
        keywords:
          "développement full stack, développement web, développement d'applications mobiles, React, Next.js, Node.js, TypeScript, DevOps",
      },
      de: {
        title: "Full-Stack-Entwicklung",
        description: "End-to-End-Web- und Mobile-Anwendungsentwicklung mit modernen Frameworks und Technologien.",
        metaDescription:
          "Professionelle Full-Stack-Entwicklungsdienste einschließlich Frontend-, Backend-, Mobile-App-Entwicklung und DevOps für Unternehmen aller Größen.",
        keywords:
          "Full-Stack-Entwicklung, Webentwicklung, Mobile-App-Entwicklung, React, Next.js, Node.js, TypeScript, DevOps",
      },
      es: {
        title: "Desarrollo Full Stack",
        description:
          "Desarrollo de aplicaciones web y móviles de extremo a extremo con frameworks y tecnologías modernas.",
        metaDescription:
          "Servicios profesionales de desarrollo full stack que incluyen desarrollo frontend, backend, de aplicaciones móviles y DevOps para empresas de todos los tamaños.",
        keywords:
          "desarrollo full stack, desarrollo web, desarrollo de aplicaciones móviles, React, Next.js, Node.js, TypeScript, DevOps",
      },
    },
  },
  {
    id: "enterprise",
    icon: "Briefcase",
    translations: {
      en: {
        title: "Enterprise Solutions",
        description: "Digital transformation, legacy system integration, and custom enterprise-grade applications.",
        metaDescription:
          "Enterprise-grade solutions including digital transformation, legacy system integration, custom applications, and strategic advisory & architecture discovery for large organizations.",
        keywords:
          "enterprise solutions, digital transformation, legacy system integration, custom applications, enterprise architecture, business process automation",
      },
      fr: {
        title: "Solutions d'Entreprise",
        description:
          "Transformation numérique, intégration de systèmes existants et applications personnalisées de niveau entreprise.",
        metaDescription:
          "Solutions de niveau entreprise comprenant la transformation numérique, l'intégration de systèmes existants, des applications personnalisées et des conseils stratégiques pour les grandes organisations.",
        keywords:
          "solutions d'entreprise, transformation numérique, intégration de systèmes existants, applications personnalisées, architecture d'entreprise, automatisation des processus métier",
      },
      de: {
        title: "Unternehmenslösungen",
        description:
          "Digitale Transformation, Integration von Legacy-Systemen und maßgeschneiderte Unternehmensanwendungen.",
        metaDescription:
          "Unternehmenslösungen einschließlich digitaler Transformation, Integration von Legacy-Systemen, maßgeschneiderten Anwendungen und strategischer Beratung für große Organisationen.",
        keywords:
          "Unternehmenslösungen, digitale Transformation, Integration von Legacy-Systemen, maßgeschneiderte Anwendungen, Unternehmensarchitektur, Geschäftsprozessautomatisierung",
      },
      es: {
        title: "Soluciones Empresariales",
        description:
          "Transformación digital, integración de sistemas heredados y aplicaciones personalizadas de nivel empresarial.",
        metaDescription:
          "Soluciones de nivel empresarial que incluyen transformación digital, integración de sistemas heredados, aplicaciones personalizadas y consultoría estratégica para grandes organizaciones.",
        keywords:
          "soluciones empresariales, transformación digital, integración de sistemas heredados, aplicaciones personalizadas, arquitectura empresarial, automatización de procesos de negocio",
      },
    },
  },
]

// Sub-services for each category
export const subServices = {
  blockchain: [
    {
      id: "smart-contracts",
      icon: "FileCode",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "AI Smart Contract Analytics",
          shortDescription:
            "Intelligent agents that analyze, audit, and interact with smart contracts on Ethereum, Solana, and more.",
          description:
            "Expert development of secure, efficient, and auditable smart contracts for various blockchain platforms. From simple token contracts to complex DeFi protocols, I deliver reliable solutions that meet your business needs.",
          metaDescription:
            "Professional smart contract development services for Ethereum, Solana, and other blockchains. Secure, efficient, and auditable smart contracts for your business needs.",
          keywords:
            "smart contracts, Ethereum, Solidity, Solana, blockchain development, DeFi contracts, NFT contracts, token development",
          features: [
            "Secure and optimized contract development",
            "Comprehensive testing and auditing",
            "Integration with existing systems",
            "Custom token creation (ERC-20, ERC-721, ERC-1155)",
            "Upgradeable smart contracts",
            "Multi-signature wallets and governance",
          ],
          process: [
            "Requirements analysis and specification",
            "Architecture design and security planning",
            "Development and internal testing",
            "Third-party security audit",
            "Deployment and verification",
            "Ongoing support and maintenance",
          ],
        },
        fr: {
          title: "Développement de Contrats Intelligents",
          shortDescription:
            "Contrats intelligents personnalisés pour diverses plateformes blockchain, notamment Ethereum, Solana et Polkadot.",
          description:
            "Développement expert de contrats intelligents sécurisés, efficaces et architecturables pour diverses plateformes blockchain. Des simples contrats de jetons aux protocoles DeFi complexes, je fournis des solutions fiables qui répondent aux besoins de votre entreprise.",
          metaDescription:
            "Services professionnels de développement de contrats intelligents pour Ethereum, Solana et autres blockchains. Contrats intelligents sécurisés, efficaces et architecturables pour les besoins de votre entreprise.",
          keywords:
            "contrats intelligents, Ethereum, Solidity, Solana, développement blockchain, contrats DeFi, contrats NFT, développement de jetons",
          features: [
            "Développement de contrats sécurisés et optimisés",
            "Tests et revues d'architecture complets",
            "Intégration avec les systèmes existants",
            "Création de jetons personnalisés (ERC-20, ERC-721, ERC-1155)",
            "Contrats intelligents évolutifs",
            "Portefeuilles multi-signatures et gouvernance",
          ],
          process: [
            "Analyse des besoins et spécification",
            "Conception de l'architecture et planification de la sécurité",
            "Développement et tests internes",
            "Revue d'architecture par un tiers",
            "Déploiement et vérification",
            "Support et maintenance continus",
          ],
        },
        de: {
          title: "Smart Contract-Entwicklung",
          shortDescription:
            "Maßgeschneiderte Smart Contracts für verschiedene Blockchain-Plattformen wie Ethereum, Solana und Polkadot.",
          description:
            "Experte für die Entwicklung sicherer, effizienter und prüfbarer Smart Contracts für verschiedene Blockchain-Plattformen. Von einfachen Token-Verträgen bis hin zu komplexen DeFi-Protokollen liefere ich zuverlässige Lösungen, die Ihren Geschäftsanforderungen entsprechen.",
          metaDescription:
            "Professionelle Smart Contract-Entwicklungsdienste für Ethereum, Solana und andere Blockchains. Sichere, effiziente und prüfbare Smart Contracts für Ihre Geschäftsanforderungen.",
          keywords:
            "Smart Contracts, Ethereum, Solidity, Solana, Blockchain-Entwicklung, DeFi-Verträge, NFT-Verträge, Token-Entwicklung",
          features: [
            "Sichere und optimierte Vertragsentwicklung",
            "Umfassende Tests und Architekturprüfungen",
            "Integration mit bestehenden Systemen",
            "Benutzerdefinierte Token-Erstellung (ERC-20, ERC-721, ERC-1155)",
            "Aktualisierbare Smart Contracts",
            "Multi-Signatur-Wallets und Governance",
          ],
          process: [
            "Anforderungsanalyse und Spezifikation",
            "Architekturdesign und Sicherheitsplanung",
            "Entwicklung und interne Tests",
            "Architekturprüfung durch Dritte",
            "Bereitstellung und Verifizierung",
            "Laufende Unterstützung und Wartung",
          ],
        },
        es: {
          title: "Desarrollo de Contratos Inteligentes",
          shortDescription:
            "Contratos inteligentes personalizados para varias plataformas blockchain, incluyendo Ethereum, Solana y Polkadot.",
          description:
            "Desarrollo experto de contratos inteligentes seguros, eficientes y architecturables para diversas plataformas blockchain. Desde simples contratos de tokens hasta complejos protocolos DeFi, entrego soluciones confiables que satisfacen las necesidades de su negocio.",
          metaDescription:
            "Servicios profesionales de desarrollo de contratos inteligentes para Ethereum, Solana y otras blockchains. Contratos inteligentes seguros, eficientes y architecturables para las necesidades de su negocio.",
          keywords:
            "contratos inteligentes, Ethereum, Solidity, Solana, desarrollo blockchain, contratos DeFi, contratos NFT, desarrollo de tokens",
          features: [
            "Desarrollo de contratos seguros y optimizados",
            "Pruebas y revisiones de arquitectura exhaustivas",
            "Integración con sistemas existentes",
            "Creación de tokens personalizados (ERC-20, ERC-721, ERC-1155)",
            "Contratos inteligentes actualizables",
            "Carteras multifirma y gobernanza",
          ],
          process: [
            "Análisis de requisitos y especificación",
            "Diseño de arquitectura y planificación de seguridad",
            "Desarrollo y pruebas internas",
            "Revisión de arquitectura por terceros",
            "Implementación y verificación",
            "Soporte y mantenimiento continuos",
          ],
        },
      },
    },
    {
      id: "defi",
      icon: "BarChart",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "AI Portfolio Management",
          shortDescription:
            "AI-driven portfolio management, predictive analytics, and automated DeFi strategies.",
          description:
            "Comprehensive DeFi solutions that enable financial services without traditional intermediaries. I develop secure and efficient decentralized exchanges, lending platforms, yield aggregators, and other DeFi applications tailored to your specific requirements.",
          metaDescription:
            "Custom DeFi development services including decentralized exchanges, lending platforms, yield farming protocols, and staking solutions for blockchain projects.",
          keywords:
            "DeFi development, decentralized finance, DEX, lending platform, yield farming, staking, liquidity pools, blockchain finance",
          features: [
            "Decentralized exchange (DEX) development",
            "Lending and borrowing platforms",
            "Yield farming and staking protocols",
            "Liquidity pool management",
            "Automated market makers (AMMs)",
            "Cross-chain DeFi solutions",
          ],
          process: [
            "DeFi market analysis and strategy",
            "Protocol design and tokenomics",
            "Smart contract development",
            "Security auditing and testing",
            "Frontend integration and UI/UX",
            "Launch and ongoing optimization",
          ],
        },
        fr: {
          title: "Solutions DeFi",
          shortDescription:
            "Applications de finance décentralisée comprenant des plateformes de prêt, des DEX et des protocoles de yield farming.",
          description:
            "Solutions DeFi complètes qui permettent des services financiers sans intermédiaires traditionnels. Je développe des échanges décentralisés, des plateformes de prêt, des agrégateurs de rendement et d'autres applications DeFi sécurisées et efficaces, adaptées à vos besoins spécifiques.",
          metaDescription:
            "Services de développement DeFi personnalisés comprenant des échanges décentralisés, des plateformes de prêt, des protocoles de yield farming et des solutions de staking pour les projets blockchain.",
          keywords:
            "développement DeFi, finance décentralisée, DEX, plateforme de prêt, yield farming, staking, pools de liquidité, finance blockchain",
          features: [
            "Développement d'échanges décentralisés (DEX)",
            "Plateformes de prêt et d'emprunt",
            "Protocoles de yield farming et de staking",
            "Gestion des pools de liquidité",
            "Market makers automatisés (AMM)",
            "Solutions DeFi multi-chaînes",
          ],
          process: [
            "Analyse du marché DeFi et stratégie",
            "Conception de protocole et tokenomics",
            "Développement de contrats intelligents",
            "Audit de sécurité et tests",
            "Intégration frontend et UI/UX",
            "Lancement et optimisation continue",
          ],
        },
        de: {
          title: "DeFi-Lösungen",
          shortDescription:
            "Dezentralisierte Finanzanwendungen einschließlich Kreditplattformen, DEXs und Yield-Farming-Protokolle.",
          description:
            "Umfassende DeFi-Lösungen, die Finanzdienstleistungen ohne traditionelle Vermittler ermöglichen. Ich entwickle sichere und effiziente dezentralisierte Börsen, Kreditplattformen, Yield-Aggregatoren und andere DeFi-Anwendungen, die auf Ihre spezifischen Anforderungen zugeschnitten sind.",
          metaDescription:
            "Maßgeschneiderte DeFi-Entwicklungsdienste einschließlich dezentralisierter Börsen, Kreditplattformen, Yield-Farming-Protokolle und Staking-Lösungen für Blockchain-Projekte.",
          keywords:
            "DeFi-Entwicklung, dezentralisierte Finanzen, DEX, Kreditplattform, Yield Farming, Staking, Liquiditätspools, Blockchain-Finanzen",
          features: [
            "Entwicklung dezentralisierter Börsen (DEX)",
            "Kredit- und Darlehensplattformen",
            "Yield-Farming- und Staking-Protokolle",
            "Verwaltung von Liquiditätspools",
            "Automatisierte Market Maker (AMMs)",
            "Cross-Chain-DeFi-Lösungen",
          ],
          process: [
            "DeFi-Marktanalyse und Strategie",
            "Protokolldesign und Tokenomics",
            "Smart-Contract-Entwicklung",
            "Architekturprüfungen und Tests",
            "Frontend-Integration und UI/UX",
            "Start und kontinuierliche Optimierung",
          ],
        },
        es: {
          title: "Soluciones DeFi",
          shortDescription:
            "Aplicaciones de finanzas descentralizadas que incluyen plataformas de préstamos, DEX y protocolos de yield farming.",
          description:
            "Soluciones DeFi completas que permiten servicios financieros sin intermediarios tradicionales. Desarrollo intercambios descentralizados, plataformas de préstamos, agregadores de rendimiento y otras aplicaciones DeFi seguras y eficientes, adaptadas a sus requisitos específicos.",
          metaDescription:
            "Servicios de desarrollo DeFi personalizados que incluyen intercambios descentralizados, plataformas de préstamos, protocolos de yield farming y soluciones de staking para proyectos blockchain.",
          keywords:
            "desarrollo DeFi, finanzas descentralizadas, DEX, plataforma de préstamos, yield farming, staking, pools de liquidez, finanzas blockchain",
          features: [
            "Desarrollo de intercambios descentralizados (DEX)",
            "Plataformas de préstamos y empréstitos",
            "Protocolos de yield farming y staking",
            "Gestión de pools de liquidez",
            "Creadores de mercado automatizados (AMMs)",
            "Soluciones DeFi multicadena",
          ],
          process: [
            "Análisis de mercado DeFi y estrategia",
            "Diseño de protocolo y tokenomics",
            "Desarrollo de contratos inteligentes",
            "Auditoría de seguridad y pruebas",
            "Integración frontend y UI/UX",
            "Lanzamiento y optimización continua",
          ],
        },
      },
    },
    {
      id: "nft",
      icon: "Image",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "NFT Platforms",
          shortDescription:
            "End-to-end NFT marketplaces and platforms for digital collectibles, art, and virtual assets.",
          description:
            "Complete NFT platform solutions for creating, minting, selling, and trading digital assets. I develop custom NFT marketplaces, galleries, and integration solutions that enable businesses and creators to leverage the full potential of non-fungible tokens.",
          metaDescription:
            "Custom NFT platform development services including marketplaces, minting solutions, galleries, and integration services for digital collectibles and assets.",
          keywords:
            "NFT platform, NFT marketplace, digital collectibles, NFT minting, NFT gallery, blockchain art, virtual assets, metaverse",
          features: [
            "Custom NFT marketplace development",
            "Minting platforms and tools",
            "NFT galleries and showcases",
            "Auction and bidding systems",
            "Royalty and revenue sharing",
            "Metaverse integration",
          ],
          process: [
            "NFT strategy and use case definition",
            "Platform architecture design",
            "Smart contract development",
            "Frontend and user experience design",
            "Testing and security auditing",
            "Launch and marketing support",
          ],
        },
        fr: {
          title: "Plateformes NFT",
          shortDescription:
            "Places de marché NFT de bout en bout et plateformes pour les objets de collection numériques, l'art et les actifs virtuels.",
          description:
            "Solutions complètes de plateforme NFT pour créer, frapper, vendre et échanger des actifs numériques. Je développe des places de marché NFT personnalisées, des galeries et des solutions d'intégration qui permettent aux entreprises et aux créateurs d'exploiter tout le potentiel des jetons non fongibles.",
          metaDescription:
            "Services de développement de plateformes NFT personnalisées comprenant des places de marché, des solutions de frappe, des galeries et des services d'intégration pour les objets de collection et les actifs numériques.",
          keywords:
            "plateforme NFT, marché NFT, objets de collection numériques, frappe NFT, galerie NFT, art blockchain, actifs virtuels, métaverse",
          features: [
            "Développement de places de marché NFT personnalisées",
            "Plateformes et outils de frappe",
            "Galeries et vitrines NFT",
            "Systèmes d'enchères et d'offres",
            "Redevances et partage des revenus",
            "Intégration au métaverse",
          ],
          process: [
            "Stratégie NFT et définition des cas d'utilisation",
            "Conception de l'architecture de la plateforme",
            "Développement de contrats intelligents",
            "Conception de l'interface et de l'expérience utilisateur",
            "Tests et revues d'architecture",
            "Support au lancement et au marketing",
          ],
        },
        de: {
          title: "NFT-Plattformen",
          shortDescription:
            "End-to-End-NFT-Marktplätze und Plattformen für digitale Sammlerstücke, Kunst und virtuelle Vermögenswerte.",
          description:
            "Komplette NFT-Plattformlösungen zum Erstellen, Prägen, Verkaufen und Handeln digitaler Vermögenswerte. Ich entwickle maßgeschneiderte NFT-Marktplätze, Galerien und Integrationslösungen, die es Unternehmen und Kreativen ermöglichen, das volle Potenzial von nicht-fungiblen Token auszuschöpfen.",
          metaDescription:
            "Maßgeschneiderte NFT-Plattformentwicklungsdienste einschließlich Marktplätze, Prägelösungen, Galerien und Integrationsdienste für digitale Sammlerstücke und Vermögenswerte.",
          keywords:
            "NFT-Plattform, NFT-Marktplatz, digitale Sammlerstücke, NFT-Prägung, NFT-Galerie, Blockchain-Kunst, virtuelle Vermögenswerte, Metaverse",
          features: [
            "Entwicklung maßgeschneiderter NFT-Marktplätze",
            "Prägeplattformen und -werkzeuge",
            "NFT-Galerien und Showcases",
            "Auktions- und Gebotssysteme",
            "Lizenzgebühren und Umsatzbeteiligung",
            "Metaverse-Integration",
          ],
          process: [
            "NFT-Strategie und Anwendungsfalldefiniton",
            "Plattformarchitekturdesign",
            "Smart-Contract-Entwicklung",
            "Frontend- und Benutzererfahrungsdesign",
            "Tests und Sicherheitsaudits",
            "Start- und Marketingunterstützung",
          ],
        },
        es: {
          title: "Plataformas NFT",
          shortDescription:
            "Mercados NFT integrales y plataformas para coleccionables digitales, arte y activos virtuales.",
          description:
            "Soluciones completas de plataformas NFT para crear, acuñar, vender e intercambiar activos digitales. Desarrollo mercados NFT personalizados, galerías y soluciones de integración que permiten a empresas y creadores aprovechar todo el potencial de los tokens no fungibles.",
          metaDescription:
            "Servicios de desarrollo de plataformas NFT personalizadas que incluyen mercados, soluciones de acuñación, galerías y servicios de integración para coleccionables y activos digitales.",
          keywords:
            "plataforma NFT, mercado NFT, coleccionables digitales, acuñación NFT, galería NFT, arte blockchain, activos virtuales, metaverso",
          features: [
            "Desarrollo de mercados NFT personalizados",
            "Plataformas y herramientas de acuñación",
            "Galerías y exhibiciones NFT",
            "Sistemas de subastas y pujas",
            "Regalías y reparto de ingresos",
            "Integración con el metaverso",
          ],
          process: [
            "Estrategia NFT y definición de casos de uso",
            "Diseño de arquitectura de plataforma",
            "Desarrollo de contratos inteligentes",
            "Diseño de frontend y experiencia de usuario",
            "Pruebas y revisión de arquitectura de seguridad",
            "Soporte de lanzamiento y marketing",
          ],
        },
      },
    },
    {
      id: "web3",
      icon: "Globe",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Web3 Integration",
          shortDescription: "Integration of Web3 technologies into existing applications and platforms.",
          description:
            "Seamless integration of Web3 technologies into existing applications and platforms. I help businesses transition to decentralized architectures, implement wallet connections, and leverage blockchain capabilities while maintaining user-friendly experiences.",
          metaDescription:
            "Professional Web3 integration services to connect existing applications with blockchain technologies, wallets, and decentralized protocols.",
          keywords:
            "Web3 integration, blockchain integration, wallet connection, dApp development, decentralized applications, Ethereum integration, Web3.js, ethers.js",
          features: [
            "Wallet integration (MetaMask, WalletConnect, etc.)",
            "Blockchain API development",
            "Web2 to Web3 migration strategies",
            "Cross-chain compatibility",
            "Decentralized identity solutions",
            "Web3 authentication systems",
          ],
          process: [
            "Integration assessment and planning",
            "Architecture design for Web3 compatibility",
            "API and connector development",
            "User experience optimization",
            "Security testing and auditing",
            "Deployment and ongoing support",
          ],
        },
        fr: {
          title: "Intégration Web3",
          shortDescription: "Intégration des technologies Web3 dans les applications et plateformes existantes.",
          description:
            "Intégration transparente des technologies Web3 dans les applications et plateformes existantes. J'aide les entreprises à passer à des architectures décentralisées, à mettre en œuvre des connexions de portefeuille et à tirer parti des capacités de la blockchain tout en maintenant des expériences conviviales.",
          metaDescription:
            "Services professionnels d'intégration Web3 pour connecter des applications existantes avec des technologies blockchain, des portefeuilles et des protocoles décentralisés.",
          keywords:
            "intégration Web3, intégration blockchain, connexion de portefeuille, développement dApp, applications décentralisées, intégration Ethereum, Web3.js, ethers.js",
          features: [
            "Intégration de portefeuille (MetaMask, WalletConnect, etc.)",
            "Développement d'API blockchain",
            "Stratégies de migration de Web2 vers Web3",
            "Compatibilité multi-chaînes",
            "Solutions d'identité décentralisées",
            "Systèmes d'authentification Web3",
          ],
          process: [
            "Évaluation et planification de l'intégration",
            "Conception d'architecture pour la compatibilité Web3",
            "Développement d'API et de connecteurs",
            "Optimisation de l'expérience utilisateur",
            "Tests de sécurité et revue d'architecture",
            "Déploiement et support continu",
          ],
        },
        de: {
          title: "Web3-Integration",
          shortDescription: "Integration von Web3-Technologien in bestehende Anwendungen und Plattformen.",
          description:
            "Nahtlose Integration von Web3-Technologien in bestehende Anwendungen und Plattformen. Ich helfe Unternehmen beim Übergang zu dezentralen Architekturen, bei der Implementierung von Wallet-Verbindungen und bei der Nutzung von Blockchain-Funktionen bei gleichzeitiger Beibehaltung benutzerfreundlicher Erfahrungen.",
          metaDescription:
            "Professionelle Web3-Integrationsdienste zur Verbindung bestehender Anwendungen mit Blockchain-Technologien, Wallets und dezentralen Protokollen.",
          keywords:
            "Web3-Integration, Blockchain-Integration, Wallet-Verbindung, dApp-Entwicklung, dezentrale Anwendungen, Ethereum-Integration, Web3.js, ethers.js",
          features: [
            "Wallet-Integration (MetaMask, WalletConnect, etc.)",
            "Blockchain-API-Entwicklung",
            "Web2-zu-Web3-Migrationsstrategien",
            "Cross-Chain-Kompatibilität",
            "Dezentrale Identitätslösungen",
            "Web3-Authentifizierungssysteme",
          ],
          process: [
            "Integrationsbewertung und -planung",
            "Architekturdesign für Web3-Kompatibilität",
            "API- und Connector-Entwicklung",
            "Optimierung der Benutzererfahrung",
            "Sicherheitstests und Architekturprüfung",
            "Bereitstellung und laufende Unterstützung",
          ],
        },
        es: {
          title: "Integración Web3",
          shortDescription: "Integración de tecnologías Web3 en aplicaciones y plataformas existentes.",
          description:
            "Integración perfecta de tecnologías Web3 en aplicaciones y plataformas existentes. Ayudo a las empresas a transicionar a arquitecturas descentralizadas, implementar conexiones de billeteras y aprovechar las capacidades de blockchain mientras mantienen experiencias amigables para el usuario.",
          metaDescription:
            "Servicios profesionales de integración Web3 para conectar aplicaciones existentes con tecnologías blockchain, billeteras y protocolos descentralizados.",
          keywords:
            "integración Web3, integración blockchain, conexión de billetera, desarrollo dApp, aplicaciones descentralizadas, integración Ethereum, Web3.js, ethers.js",
          features: [
            "Integración de billeteras (MetaMask, WalletConnect, etc.)",
            "Desarrollo de API blockchain",
            "Estrategias de migración de Web2 a Web3",
            "Compatibilidad entre cadenas",
            "Soluciones de identidad descentralizada",
            "Sistemas de autenticación Web3",
          ],
          process: [
            "Evaluación y planificación de integración",
            "Diseño de arquitectura para compatibilidad Web3",
            "Desarrollo de API y conectores",
            "Optimización de experiencia de usuario",
            "Pruebas de seguridad y revisión de arquitectura",
            "Implementación y soporte continuo",
          ],
        },
      },
    },
  ],
  genai: [
    {
      id: "multi-agent",
      icon: "Network",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Multi-Agent System Orchestration",
          shortDescription: "Architecture and deployment of multi-agent systems where specialized AI agents collaborate.",
          description: "Architecture and deployment of multi-agent systems (like CrewAI, LangGraph) where specialized AI agents collaborate to solve complex tasks. Real-world example: A financial research system where a 'Data Gatherer' agent pulls real-time market data, a 'Quant Analyst' agent processes the numbers, and a 'Report Writer' agent generates the final investment memo.",
          metaDescription: "Professional multi-agent orchestration services.",
          keywords: "Multi-agent systems, CrewAI, LangGraph, agent orchestration, AI teams",
          features: [
            "Agent specialization and role definition",
            "Multi-agent communication protocols",
            "State management across agent workflows",
            "Human-in-the-loop review nodes",
            "Deterministic tool execution",
            "Performance monitoring and tracing",
          ],
          process: [
            "Workflow decomposition",
            "Agent persona design",
            "Tool integration",
            "Graph/Sequence implementation",
            "Simulation and tuning",
            "Production deployment",
          ],
        },
      },
    },
    {
      id: "llm",
      icon: "MessageSquare",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "LLM Integration",
          shortDescription:
            "Integration of large language models into applications for enhanced functionality and user experience.",
          description:
            "Expert integration of large language models (LLMs) into applications and platforms. I help businesses leverage the power of advanced AI models like GPT-4, Claude, and others to enhance product capabilities, automate processes, and create innovative user experiences.",
          metaDescription:
            "Professional LLM integration services to incorporate advanced AI language models into your applications for enhanced functionality and user experiences.",
          keywords:
            "LLM integration, large language models, GPT integration, AI implementation, natural language processing, AI-powered applications, OpenAI API",
          features: [
            "Custom LLM integration with existing applications",
            "Fine-tuning models for specific use cases",
            "Prompt engineering and optimization",
            "Context management and memory systems",
            "Multi-modal AI integration (text, images, audio)",
            "Scalable AI infrastructure design",
          ],
          process: [
            "Use case analysis and model selection",
            "Integration architecture design",
            "API development and implementation",
            "Prompt design and optimization",
            "Testing and performance tuning",
            "Deployment and monitoring setup",
          ],
        },
        fr: {
          title: "Intégration LLM",
          shortDescription:
            "Intégration de grands modèles de langage dans les applications pour une fonctionnalité et une expérience utilisateur améliorées.",
          description:
            "Intégration experte de grands modèles de langage (LLM) dans les applications et plateformes. J'aide les entreprises à exploiter la puissance des modèles d'IA avancés comme GPT-4, Claude et autres pour améliorer les capacités des produits, automatiser les processus et créer des expériences utilisateur innovantes.",
          metaDescription:
            "Services professionnels d'intégration LLM pour incorporer des modèles de langage IA avancés dans vos applications pour des fonctionnalités et des expériences utilisateur améliorées.",
          keywords:
            "intégration LLM, grands modèles de langage, intégration GPT, implémentation IA, traitement du langage naturel, applications alimentées par l'IA, API OpenAI",
          features: [
            "Intégration LLM personnalisée avec des applications existantes",
            "Ajustement fin des modèles pour des cas d'utilisation spécifiques",
            "Ingénierie et optimisation des prompts",
            "Gestion du contexte et systèmes de mémoire",
            "Intégration IA multimodale (texte, images, audio)",
            "Conception d'infrastructure IA évolutive",
          ],
          process: [
            "Analyse de cas d'utilisation et sélection de modèle",
            "Conception d'architecture d'intégration",
            "Développement et implémentation d'API",
            "Conception et optimisation de prompts",
            "Tests et réglage des performances",
            "Configuration de déploiement et de surveillance",
          ],
        },
        de: {
          title: "LLM-Integration",
          shortDescription:
            "Integration großer Sprachmodelle in Anwendungen für verbesserte Funktionalität und Benutzererfahrung.",
          description:
            "Experte für die Integration großer Sprachmodelle (LLMs) in Anwendungen und Plattformen. Ich helfe Unternehmen, die Leistungsfähigkeit fortschrittlicher KI-Modelle wie GPT-4, Claude und andere zu nutzen, um Produktfunktionen zu verbessern, Prozesse zu automatisieren und innovative Benutzererfahrungen zu schaffen.",
          metaDescription:
            "Professionelle LLM-Integrationsdienste zur Einbindung fortschrittlicher KI-Sprachmodelle in Ihre Anwendungen für verbesserte Funktionalität und Benutzererfahrungen.",
          keywords:
            "LLM-Integration, große Sprachmodelle, GPT-Integration, KI-Implementierung, natürliche Sprachverarbeitung, KI-gestützte Anwendungen, OpenAI API",
          features: [
            "Maßgeschneiderte LLM-Integration mit bestehenden Anwendungen",
            "Feinabstimmung von Modellen für spezifische Anwendungsfälle",
            "Prompt-Engineering und -Optimierung",
            "Kontextverwaltung und Speichersysteme",
            "Multimodale KI-Integration (Text, Bilder, Audio)",
            "Skalierbares KI-Infrastrukturdesign",
          ],
          process: [
            "Anwendungsfallanalyse und Modellauswahl",
            "Integrationsarchitekturdesign",
            "API-Entwicklung und -Implementierung",
            "Prompt-Design und -Optimierung",
            "Tests und Leistungsoptimierung",
            "Einrichtung von Bereitstellung und Überwachung",
          ],
        },
        es: {
          title: "Integración de LLM",
          shortDescription:
            "Integración de grandes modelos de lenguaje en aplicaciones para mejorar la funcionalidad y la experiencia del usuario.",
          description:
            "Integración experta de grandes modelos de lenguaje (LLMs) en aplicaciones y plataformas. Ayudo a las empresas a aprovechar el poder de modelos avanzados de IA como GPT-4, Claude y otros para mejorar las capacidades del producto, automatizar procesos y crear experiencias de usuario innovadoras.",
          metaDescription:
            "Servicios profesionales de integración de LLM para incorporar modelos avanzados de lenguaje de IA en sus aplicaciones para mejorar la funcionalidad y las experiencias de usuario.",
          keywords:
            "integración de LLM, grandes modelos de lenguaje, integración de GPT, implementación de IA, procesamiento de lenguaje natural, aplicaciones impulsadas por IA, API de OpenAI",
          features: [
            "Integración personalizada de LLM con aplicaciones existentes",
            "Ajuste fino de modelos para casos de uso específicos",
            "Ingeniería y optimización de prompts",
            "Gestión de contexto y sistemas de memoria",
            "Integración de IA multimodal (texto, imágenes, audio)",
            "Diseño de infraestructura de IA escalable",
          ],
          process: [
            "Análisis de casos de uso y selección de modelos",
            "Diseño de arquitectura de integración",
            "Desarrollo e implementación de API",
            "Diseño y optimización de prompts",
            "Pruebas y ajuste de rendimiento",
            "Configuración de implementación y monitoreo",
          ],
        },
      },
    },
    {
      id: "assistants",
      icon: "Bot",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "AI Assistants",
          shortDescription: "Custom AI assistants for customer support, content generation, and process automation.",
          description:
            "Tailored AI assistant solutions that automate tasks, enhance customer support, and streamline operations. I develop intelligent virtual assistants that understand natural language, learn from interactions, and provide valuable services across various business functions.",
          metaDescription:
            "Custom AI assistant development services for customer support, content generation, process automation, and other business applications.",
          keywords:
            "AI assistants, virtual assistants, chatbots, conversational AI, customer support automation, AI agents, intelligent automation",
          features: [
            "Natural language understanding and generation",
            "Multi-channel deployment (web, mobile, messaging)",
            "Knowledge base integration",
            "Personalization and context awareness",
            "Analytics and continuous improvement",
            "Human handoff capabilities",
          ],
          process: [
            "Business requirements and use case definition",
            "Conversation design and knowledge mapping",
            "AI model selection and customization",
            "Integration with existing systems",
            "Training and testing",
            "Deployment and performance monitoring",
          ],
        },
        fr: {
          title: "Assistants IA",
          shortDescription:
            "Assistants IA personnalisés pour le support client, la génération de contenu et l'automatisation des processus.",
          description:
            "Solutions d'assistant IA sur mesure qui automatisent les tâches, améliorent le support client et rationalisent les opérations. Je développe des assistants virtuels intelligents qui comprennent le langage naturel, apprennent des interactions et fournissent des services précieux à travers diverses fonctions commerciales.",
          metaDescription:
            "Services de développement d'assistants IA personnalisés pour le support client, la génération de contenu, l'automatisation des processus et d'autres applications commerciales.",
          keywords:
            "assistants IA, assistants virtuels, chatbots, IA conversationnelle, automatisation du support client, agents IA, automatisation intelligente",
          features: [
            "Compréhension et génération du langage naturel",
            "Déploiement multicanal (web, mobile, messagerie)",
            "Intégration de base de connaissances",
            "Personnalisation et sensibilité au contexte",
            "Analytique et amélioration continue",
            "Capacités de transfert humain",
          ],
          process: [
            "Exigences commerciales et définition de cas d'utilisation",
            "Conception de conversation et cartographie des connaissances",
            "Sélection et personnalisation du modèle IA",
            "Intégration avec les systèmes existants",
            "Formation et tests",
            "Déploiement et surveillance des performances",
          ],
        },
        de: {
          title: "KI-Assistenten",
          shortDescription:
            "Maßgeschneiderte KI-Assistenten für Kundensupport, Inhaltserstellung und Prozessautomatisierung.",
          description:
            "Maßgeschneiderte KI-Assistentenlösungen, die Aufgaben automatisieren, den Kundensupport verbessern und Abläufe optimieren. Ich entwickle intelligente virtuelle Assistenten, die natürliche Sprache verstehen, aus Interaktionen lernen und wertvolle Dienste für verschiedene Geschäftsfunktionen bereitstellen.",
          metaDescription:
            "Maßgeschneiderte KI-Assistentenentwicklungsdienste für Kundensupport, Inhaltserstellung, Prozessautomatisierung und andere Geschäftsanwendungen.",
          keywords:
            "KI-Assistenten, virtuelle Assistenten, Chatbots, Konversations-KI, Kundensupport-Automatisierung, KI-Agenten, intelligente Automatisierung",
          features: [
            "Verstehen und Generieren natürlicher Sprache",
            "Multi-Channel-Bereitstellung (Web, Mobil, Messaging)",
            "Wissensdatenbankintegration",
            "Personalisierung und Kontextbewusstsein",
            "Analytik und kontinuierliche Verbesserung",
            "Menschliche Übergabefähigkeiten",
          ],
          process: [
            "Geschäftsanforderungen und Anwendungsfalldefinition",
            "Konversationsdesign und Wissenskartierung",
            "KI-Modellauswahl und -anpassung",
            "Integration mit bestehenden Systemen",
            "Training und Tests",
            "Bereitstellung und Leistungsüberwachung",
          ],
        },
        es: {
          title: "Asistentes de IA",
          shortDescription:
            "Asistentes de IA personalizados para soporte al cliente, generación de contenido y automatización de procesos.",
          description:
            "Soluciones de asistentes de IA a medida que automatizan tareas, mejoran el soporte al cliente y optimizan las operaciones. Desarrollo asistentes virtuales inteligentes que entienden el lenguaje natural, aprenden de las interacciones y proporcionan servicios valiosos en diversas funciones empresariales.",
          metaDescription:
            "Servicios de desarrollo de asistentes de IA personalizados para soporte al cliente, generación de contenido, automatización de procesos y otras aplicaciones empresariales.",
          keywords:
            "asistentes de IA, asistentes virtuales, chatbots, IA conversacional, automatización de soporte al cliente, agentes de IA, automatización inteligente",
          features: [
            "Comprensión y generación de lenguaje natural",
            "Implementación multicanal (web, móvil, mensajería)",
            "Integración de base de conocimientos",
            "Personalización y conciencia del contexto",
            "Análisis y mejora continua",
            "Capacidades de transferencia humana",
          ],
          process: [
            "Requisitos comerciales y definición de casos de uso",
            "Diseño de conversación y mapeo de conocimientos",
            "Selección y personalización de modelos de IA",
            "Integración con sistemas existentes",
            "Entrenamiento y pruebas",
            "Implementación y monitoreo de rendimiento",
          ],
        },
      },
    },
    {
      id: "vision",
      icon: "Eye",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Computer Vision",
          shortDescription:
            "Computer vision solutions for image recognition, object detection, and visual data analysis.",
          description:
            "Advanced computer vision solutions that enable machines to interpret and understand visual information. I develop custom applications for image recognition, object detection, facial analysis, and other visual data processing tasks across various industries.",
          metaDescription:
            "Custom computer vision development services for image recognition, object detection, visual data analysis, and other AI-powered visual processing applications.",
          keywords:
            "computer vision, image recognition, object detection, visual AI, image processing, facial recognition, visual data analysis, machine vision",
          features: [
            "Image classification and recognition",
            "Object detection and tracking",
            "Facial analysis and recognition",
            "Optical character recognition (OCR)",
            "Visual anomaly detection",
            "Augmented reality integration",
          ],
          process: [
            "Visual data requirements analysis",
            "Model selection and architecture design",
            "Data collection and preparation",
            "Model training and optimization",
            "Integration with existing systems",
            "Deployment and performance monitoring",
          ],
        },
        fr: {
          title: "Vision par Ordinateur",
          shortDescription:
            "Solutions de vision par ordinateur pour la reconnaissance d'images, la détection d'objets et l'analyse de données visuelles.",
          description:
            "Solutions avancées de vision par ordinateur qui permettent aux machines d'interpréter et de comprendre les informations visuelles. Je développe des applications personnalisées pour la reconnaissance d'images, la détection d'objets, l'analyse faciale et d'autres tâches de traitement de données visuelles dans divers secteurs.",
          metaDescription:
            "Services de développement de vision par ordinateur personnalisés pour la reconnaissance d'images, la détection d'objets, l'analyse de données visuelles et d'autres applications de traitement visuel alimentées par l'IA.",
          keywords:
            "vision par ordinateur, reconnaissance d'images, détection d'objets, IA visuelle, traitement d'images, reconnaissance faciale, analyse de données visuelles, vision machine",
          features: [
            "Classification et reconnaissance d'images",
            "Détection et suivi d'objets",
            "Analyse et reconnaissance faciale",
            "Reconnaissance optique de caractères (OCR)",
            "Détection d'anomalies visuelles",
            "Intégration de réalité augmentée",
          ],
          process: [
            "Analyse des besoins en données visuelles",
            "Sélection de modèle et conception d'architecture",
            "Collecte et préparation des données",
            "Formation et optimisation du modèle",
            "Intégration avec les systèmes existants",
            "Déploiement et surveillance des performances",
          ],
        },
        de: {
          title: "Computer Vision",
          shortDescription: "Computer-Vision-Lösungen für Bilderkennung, Objekterkennung und visuelle Datenanalyse.",
          description:
            "Fortschrittliche Computer-Vision-Lösungen, die es Maschinen ermöglichen, visuelle Informationen zu interpretieren und zu verstehen. Ich entwickle maßgeschneiderte Anwendungen für Bilderkennung, Objekterkennung, Gesichtsanalyse und andere visuelle Datenverarbeitungsaufgaben in verschiedenen Branchen.",
          metaDescription:
            "Maßgeschneiderte Computer-Vision-Entwicklungsdienste für Bilderkennung, Objekterkennung, visuelle Datenanalyse und andere KI-gestützte visuelle Verarbeitungsanwendungen.",
          keywords:
            "Computer Vision, Bilderkennung, Objekterkennung, visuelle KI, Bildverarbeitung, Gesichtserkennung, visuelle Datenanalyse, maschinelles Sehen",
          features: [
            "Bildklassifizierung und -erkennung",
            "Objekterkennung und -verfolgung",
            "Gesichtsanalyse und -erkennung",
            "Optische Zeichenerkennung (OCR)",
            "Visuelle Anomalieerkennung",
            "Augmented-Reality-Integration",
          ],
          process: [
            "Analyse der visuellen Datenanforderungen",
            "Modellauswahl und Architekturdesign",
            "Datenerfassung und -vorbereitung",
            "Modelltraining und -optimierung",
            "Integration mit bestehenden Systemen",
            "Bereitstellung und Leistungsüberwachung",
          ],
        },
        es: {
          title: "Visión por Computadora",
          shortDescription:
            "Soluciones de visión por computadora para reconocimiento de imágenes, detección de objetos y análisis de datos visuales.",
          description:
            "Soluciones avanzadas de visión por computadora que permiten a las máquinas interpretar y comprender información visual. Desarrollo aplicaciones personalizadas para reconocimiento de imágenes, detección de objetos, análisis facial y otras tareas de procesamiento de datos visuales en diversas industrias.",
          metaDescription:
            "Servicios de desarrollo de visión por computadora personalizados para reconocimiento de imágenes, detección de objetos, análisis de datos visuales y otras aplicaciones de procesamiento visual impulsadas por IA.",
          keywords:
            "visión por computadora, reconocimiento de imágenes, detección de objetos, IA visual, procesamiento de imágenes, reconocimiento facial, análisis de datos visuales, visión artificial",
          features: [
            "Clasificación y reconocimiento de imágenes",
            "Detección y seguimiento de objetos",
            "Análisis y reconocimiento facial",
            "Reconocimiento óptico de caracteres (OCR)",
            "Detección de anomalías visuales",
            "Integración de realidad aumentada",
          ],
          process: [
            "Análisis de requisitos de datos visuales",
            "Selección de modelos y diseño de arquitectura",
            "Recopilación y preparación de datos",
            "Entrenamiento y optimización de modelos",
            "Integración con sistemas existentes",
            "Implementación y monitoreo de rendimiento",
          ],
        },
      },
    },
    {
      id: "nlp",
      icon: "FileText",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "NLP Solutions",
          shortDescription:
            "Natural language processing solutions for text analysis, sentiment analysis, and language understanding.",
          description:
            "Comprehensive natural language processing (NLP) solutions that enable machines to understand, interpret, and generate human language. I develop custom NLP applications for text analysis, sentiment analysis, language translation, and other language-related tasks.",
          metaDescription:
            "Custom natural language processing (NLP) solutions for text analysis, sentiment analysis, language understanding, and other text-based AI applications.",
          keywords:
            "natural language processing, NLP, text analysis, sentiment analysis, language understanding, text classification, named entity recognition, language AI",
          features: [
            "Text classification and categorization",
            "Sentiment analysis and opinion mining",
            "Named entity recognition",
            "Text summarization and generation",
            "Language translation and localization",
            "Conversational interfaces",
          ],
          process: [
            "Language requirements and use case analysis",
            "Data collection and preprocessing",
            "Model selection and customization",
            "Training and fine-tuning",
            "Evaluation and optimization",
            "Integration and deployment",
          ],
        },
        fr: {
          title: "Solutions NLP",
          shortDescription:
            "Solutions de traitement du langage naturel pour l'analyse de texte, l'analyse de sentiment et la compréhension du langage.",
          description:
            "Solutions complètes de traitement du langage naturel (NLP) qui permettent aux machines de comprendre, d'interpréter et de générer le langage humain. Je développe des applications NLP personnalisées pour l'analyse de texte, l'analyse de sentiment, la traduction linguistique et d'autres tâches liées au langage.",
          metaDescription:
            "Solutions personnalisées de traitement du langage naturel (NLP) pour l'analyse de texte, l'analyse de sentiment, la compréhension du langage et d'autres applications d'IA basées sur le texte.",
          keywords:
            "traitement du langage naturel, NLP, analyse de texte, analyse de sentiment, compréhension du langage, classification de texte, reconnaissance d'entités nommées, IA du langage",
          features: [
            "Classification et catégorisation de texte",
            "Analyse de sentiment et extraction d'opinion",
            "Reconnaissance d'entités nommées",
            "Résumé et génération de texte",
            "Traduction et localisation linguistique",
            "Interfaces conversationnelles",
          ],
          process: [
            "Exigences linguistiques et analyse de cas d'utilisation",
            "Collecte et prétraitement des données",
            "Sélection et personnalisation du modèle",
            "Formation et ajustement fin",
            "Évaluation et optimisation",
            "Intégration et déploiement",
          ],
        },
        de: {
          title: "NLP-Lösungen",
          shortDescription:
            "Lösungen zur Verarbeitung natürlicher Sprache für Textanalyse, Stimmungsanalyse und Sprachverständnis.",
          description:
            "Umfassende Lösungen zur Verarbeitung natürlicher Sprache (NLP), die es Maschinen ermöglichen, menschliche Sprache zu verstehen, zu interpretieren und zu generieren. Ich entwickle maßgeschneiderte NLP-Anwendungen für Textanalyse, Stimmungsanalyse, Sprachübersetzung und andere sprachbezogene Aufgaben.",
          metaDescription:
            "Maßgeschneiderte Lösungen zur Verarbeitung natürlicher Sprache (NLP) für Textanalyse, Stimmungsanalyse, Sprachverständnis und andere textbasierte KI-Anwendungen.",
          keywords:
            "Verarbeitung natürlicher Sprache, NLP, Textanalyse, Stimmungsanalyse, Sprachverständnis, Textklassifizierung, Eigennamenerkennung, Sprach-KI",
          features: [
            "Textklassifizierung und -kategorisierung",
            "Stimmungsanalyse und Meinungsgewinnung",
            "Eigennamenerkennung",
            "Textzusammenfassung und -generierung",
            "Sprachübersetzung und Lokalisierung",
            "Konversationsschnittstellen",
          ],
          process: [
            "Sprachanforderungen und Anwendungsfallanalyse",
            "Datenerfassung und -vorverarbeitung",
            "Modellauswahl und -anpassung",
            "Training und Feinabstimmung",
            "Bewertung und Optimierung",
            "Integration und Bereitstellung",
          ],
        },
        es: {
          title: "Soluciones NLP",
          shortDescription:
            "Soluciones de procesamiento de lenguaje natural para análisis de texto, análisis de sentimiento y comprensión del lenguaje.",
          description:
            "Soluciones completas de procesamiento de lenguaje natural (NLP) que permiten a las máquinas entender, interpretar y generar lenguaje humano. Desarrollo aplicaciones NLP personalizadas para análisis de texto, análisis de sentimiento, traducción de idiomas y otras tareas relacionadas con el lenguaje.",
          metaDescription:
            "Soluciones personalizadas de procesamiento de lenguaje natural (NLP) para análisis de texto, análisis de sentimiento, comprensión del lenguaje y otras aplicaciones de IA basadas en texto.",
          keywords:
            "procesamiento de lenguaje natural, NLP, análisis de texto, análisis de sentimiento, comprensión del lenguaje, clasificación de texto, reconocimiento de entidades nombradas, IA de lenguaje",
          features: [
            "Clasificación y categorización de texto",
            "Análisis de sentimiento y minería de opiniones",
            "Reconocimiento de entidades nombradas",
            "Resumen y generación de texto",
            "Traducción de idiomas y localización",
            "Interfaces conversacionales",
          ],
          process: [
            "Requisitos de lenguaje y análisis de casos de uso",
            "Recopilación y preprocesamiento de datos",
            "Selección y personalización de modelos",
            "Entrenamiento y ajuste fino",
            "Evaluación y optimización",
            "Integración e implementación",
          ],
        },
      },
    },
  ],
  development: [
    {
      id: "frontend",
      icon: "Layout",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Frontend Development",
          shortDescription:
            "Modern, responsive frontend applications using React, Next.js, and other cutting-edge frameworks.",
          description:
            "Expert frontend development services that create engaging, responsive, and high-performance user interfaces. I specialize in building modern web applications using React, Next.js, and other cutting-edge frameworks with a focus on performance, accessibility, and user experience.",
          metaDescription:
            "Professional frontend development services using React, Next.js, and other modern frameworks to create responsive, accessible, and high-performance web applications.",
          keywords:
            "frontend development, React, Next.js, TypeScript, responsive design, UI/UX, web applications, single-page applications",
          features: [
            "Responsive and mobile-first design",
            "Component-based architecture",
            "State management solutions",
            "Performance optimization",
            "Accessibility compliance (WCAG)",
            "Cross-browser compatibility",
          ],
          process: [
            "UI/UX requirements gathering",
            "Component architecture design",
            "Responsive interface development",
            "State management implementation",
            "Testing and optimization",
            "Deployment and maintenance",
          ],
        },
        fr: {
          title: "Développement Frontend",
          shortDescription:
            "Applications frontend modernes et responsives utilisant React, Next.js et autres frameworks de pointe.",
          description:
            "Services de développement frontend experts qui créent des interfaces utilisateur attrayantes, responsives et performantes. Je me spécialise dans la création d'applications web modernes utilisant React, Next.js et autres frameworks de pointe avec un accent sur la performance, l'accessibilité et l'expérience utilisateur.",
          metaDescription:
            "Services professionnels de développement frontend utilisant React, Next.js et autres frameworks modernes pour créer des applications web responsives, accessibles et performantes.",
          keywords:
            "développement frontend, React, Next.js, TypeScript, design responsive, UI/UX, applications web, applications à page unique",
          features: [
            "Design responsive et mobile-first",
            "Architecture basée sur les composants",
            "Solutions de gestion d'état",
            "Optimisation des performances",
            "Conformité d'accessibilité (WCAG)",
            "Compatibilité multi-navigateurs",
          ],
          process: [
            "Recueil des exigences UI/UX",
            "Conception de l'architecture des composants",
            "Développement d'interface responsive",
            "Implémentation de la gestion d'état",
            "Tests et optimisation",
            "Déploiement et maintenance",
          ],
        },
        de: {
          title: "Frontend-Entwicklung",
          shortDescription:
            "Moderne, responsive Frontend-Anwendungen mit React, Next.js und anderen hochmodernen Frameworks.",
          description:
            "Experten-Frontend-Entwicklungsdienste, die ansprechende, responsive und leistungsstarke Benutzeroberflächen erstellen. Ich bin spezialisiert auf die Entwicklung moderner Webanwendungen mit React, Next.js und anderen hochmodernen Frameworks mit Fokus auf Leistung, Barrierefreiheit und Benutzererfahrung.",
          metaDescription:
            "Professionelle Frontend-Entwicklungsdienste mit React, Next.js und anderen modernen Frameworks zur Erstellung responsiver, barrierefreier und leistungsstarker Webanwendungen.",
          keywords:
            "Frontend-Entwicklung, React, Next.js, TypeScript, responsives Design, UI/UX, Webanwendungen, Single-Page-Anwendungen",
          features: [
            "Responsives und Mobile-First-Design",
            "Komponentenbasierte Architektur",
            "State-Management-Lösungen",
            "Leistungsoptimierung",
            "Barrierefreiheitskonformität (WCAG)",
            "Browserübergreifende Kompatibilität",
          ],
          process: [
            "UI/UX-Anforderungserfassung",
            "Komponentenarchitekturdesign",
            "Responsive Schnittstellenentwicklung",
            "State-Management-Implementierung",
            "Tests und Optimierung",
            "Bereitstellung und Wartung",
          ],
        },
        es: {
          title: "Desarrollo Frontend",
          shortDescription:
            "Aplicaciones frontend modernas y responsivas utilizando React, Next.js y otros frameworks de vanguardia.",
          description:
            "Servicios expertos de desarrollo frontend que crean interfaces de usuario atractivas, responsivas y de alto rendimiento. Me especializo en crear aplicaciones web modernas utilizando React, Next.js y otros frameworks de vanguardia con un enfoque en el rendimiento, la accesibilidad y la experiencia del usuario.",
          metaDescription:
            "Servicios profesionales de desarrollo frontend utilizando React, Next.js y otros frameworks modernos para crear aplicaciones web responsivas, accesibles y de alto rendimiento.",
          keywords:
            "desarrollo frontend, React, Next.js, TypeScript, diseño responsivo, UI/UX, aplicaciones web, aplicaciones de página única",
          features: [
            "Diseño responsivo y mobile-first",
            "Arquitectura basada en componentes",
            "Soluciones de gestión de estado",
            "Optimización de rendimiento",
            "Cumplimiento de accesibilidad (WCAG)",
            "Compatibilidad entre navegadores",
          ],
          process: [
            "Recopilación de requisitos UI/UX",
            "Diseño de arquitectura de componentes",
            "Desarrollo de interfaz responsiva",
            "Implementación de gestión de estado",
            "Pruebas y optimización",
            "Implementación y mantenimiento",
          ],
        },
      },
    },
    {
      id: "backend",
      icon: "Server",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Backend Development",
          shortDescription:
            "Scalable, secure backend systems using Node.js, Python, and other server-side technologies.",
          description:
            "Robust backend development services that power modern applications with scalable, secure, and efficient server-side solutions. I specialize in building APIs, microservices, and data processing systems using Node.js, Python, and other server-side technologies.",
          metaDescription:
            "Professional backend development services using Node.js, Python, and other server-side technologies to create scalable, secure, and efficient application backends.",
          keywords:
            "backend development, Node.js, Python, API development, microservices, database design, server-side programming, cloud infrastructure",
          features: [
            "RESTful and GraphQL API development",
            "Microservices architecture",
            "Database design and optimization",
            "Authentication and authorization systems",
            "Real-time data processing",
            "Cloud-native development",
          ],
          process: [
            "System architecture design",
            "API and service specification",
            "Database schema design",
            "Backend implementation",
            "Security and performance testing",
            "Deployment and monitoring setup",
          ],
        },
        fr: {
          title: "Développement Backend",
          shortDescription:
            "Systèmes backend évolutifs et sécurisés utilisant Node.js, Python et autres technologies côté serveur.",
          description:
            "Services de développement backend robustes qui alimentent les applications modernes avec des solutions côté serveur évolutives, sécurisées et efficaces. Je me spécialise dans la création d'API, de microservices et de systèmes de traitement de données utilisant Node.js, Python et autres technologies côté serveur.",
          metaDescription:
            "Services professionnels de développement backend utilisant Node.js, Python et autres technologies côté serveur pour créer des backends d'applications évolutifs, sécurisés et efficaces.",
          keywords:
            "développement backend, Node.js, Python, développement d'API, microservices, conception de base de données, programmation côté serveur, infrastructure cloud",
          features: [
            "Développement d'API RESTful et GraphQL",
            "Architecture de microservices",
            "Conception et optimisation de bases de données",
            "Systèmes d'authentification et d'autorisation",
            "Traitement de données en temps réel",
            "Développement cloud-native",
          ],
          process: [
            "Conception de l'architecture système",
            "Spécification d'API et de services",
            "Conception de schéma de base de données",
            "Implémentation backend",
            "Tests de sécurité et de performance",
            "Configuration de déploiement et de surveillance",
          ],
        },
        de: {
          title: "Backend-Entwicklung",
          shortDescription:
            "Skalierbare, sichere Backend-Systeme mit Node.js, Python und anderen serverseitigen Technologien.",
          description:
            "Robuste Backend-Entwicklungsdienste, die moderne Anwendungen mit skalierbaren, sicheren und effizienten serverseitigen Lösungen antreiben. Ich bin spezialisiert auf die Entwicklung von APIs, Microservices und Datenverarbeitungssystemen mit Node.js, Python und anderen serverseitigen Technologien.",
          metaDescription:
            "Professionelle Backend-Entwicklungsdienste mit Node.js, Python und anderen serverseitigen Technologien zur Erstellung skalierbarer, sicherer und effizienter Anwendungs-Backends.",
          keywords:
            "Backend-Entwicklung, Node.js, Python, API-Entwicklung, Microservices, Datenbankdesign, serverseitige Programmierung, Cloud-Infrastruktur",
          features: [
            "RESTful- und GraphQL-API-Entwicklung",
            "Microservices-Architektur",
            "Datenbankdesign und -optimierung",
            "Authentifizierungs- und Autorisierungssysteme",
            "Echtzeit-Datenverarbeitung",
            "Cloud-native Entwicklung",
          ],
          process: [
            "Systemarchitekturdesign",
            "API- und Service-Spezifikation",
            "Datenbankschemadesign",
            "Backend-Implementierung",
            "Sicherheits- und Leistungstests",
            "Einrichtung von Bereitstellung und Überwachung",
          ],
        },
        es: {
          title: "Desarrollo Backend",
          shortDescription:
            "Sistemas backend escalables y seguros utilizando Node.js, Python y otras tecnologías del lado del servidor.",
          description:
            "Servicios robustos de desarrollo backend que potencian aplicaciones modernas con soluciones escalables, seguras y eficientes del lado del servidor. Me especializo en crear APIs, microservicios y sistemas de procesamiento de datos utilizando Node.js, Python y otras tecnologías del lado del servidor.",
          metaDescription:
            "Servicios profesionales de desarrollo backend utilizando Node.js, Python y otras tecnologías del lado del servidor para crear backends de aplicaciones escalables, seguros y eficientes.",
          keywords:
            "desarrollo backend, Node.js, Python, desarrollo de API, microservicios, diseño de bases de datos, programación del lado del servidor, infraestructura en la nube",
          features: [
            "Desarrollo de API RESTful y GraphQL",
            "Arquitectura de microservicios",
            "Diseño y optimización de bases de datos",
            "Sistemas de autenticación y autorización",
            "Procesamiento de datos en tiempo real",
            "Desarrollo nativo en la nube",
          ],
          process: [
            "Diseño de arquitectura de sistema",
            "Especificación de API y servicios",
            "Diseño de esquema de base de datos",
            "Implementación de backend",
            "Pruebas de seguridad y rendimiento",
            "Configuración de implementación y monitoreo",
          ],
        },
      },
    },
    {
      id: "mobile",
      icon: "Smartphone",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Mobile App Development",
          shortDescription: "Cross-platform mobile applications for iOS and Android using React Native and Flutter.",
          description:
            "Comprehensive mobile app development services that deliver high-quality native and cross-platform applications. I specialize in creating engaging, performant mobile experiences using React Native, Flutter, and native development approaches for both iOS and Android platforms.",
          metaDescription:
            "Professional mobile app development services for iOS and Android using React Native, Flutter, and native technologies to create engaging and high-performance applications.",
          keywords:
            "mobile app development, React Native, Flutter, iOS development, Android development, cross-platform apps, mobile UI/UX, app performance",
          features: [
            "Cross-platform development",
            "Native iOS and Android development",
            "Responsive UI design",
            "Offline functionality",
            "Device feature integration",
            "App store optimization",
          ],
          process: [
            "Mobile app strategy and planning",
            "UI/UX design for mobile",
            "App architecture design",
            "Development and testing",
            "Performance optimization",
            "App store submission and launch",
          ],
        },
        fr: {
          title: "Développement d'Applications Mobiles",
          shortDescription:
            "Applications mobiles multiplateformes pour iOS et Android utilisant React Native et Flutter.",
          description:
            "Services complets de développement d'applications mobiles qui fournissent des applications natives et multiplateformes de haute qualité. Je me spécialise dans la création d'expériences mobiles engageantes et performantes utilisant React Native, Flutter et des approches de développement natif pour les plateformes iOS et Android.",
          metaDescription:
            "Services professionnels de développement d'applications mobiles pour iOS et Android utilisant React Native, Flutter et des technologies natives pour créer des applications engageantes et performantes.",
          keywords:
            "développement d'applications mobiles, React Native, Flutter, développement iOS, développement Android, applications multiplateformes, UI/UX mobile, performance d'application",
          features: [
            "Développement multiplateforme",
            "Développement natif iOS et Android",
            "Conception d'interface utilisateur responsive",
            "Fonctionnalité hors ligne",
            "Intégration des fonctionnalités de l'appareil",
            "Optimisation pour les app stores",
          ],
          process: [
            "Stratégie et planification d'application mobile",
            "Conception UI/UX pour mobile",
            "Conception de l'architecture de l'application",
            "Développement et tests",
            "Optimisation des performances",
            "Soumission et lancement sur les app stores",
          ],
        },
        de: {
          title: "Mobile App-Entwicklung",
          shortDescription:
            "Plattformübergreifende mobile Anwendungen für iOS und Android mit React Native und Flutter.",
          description:
            "Umfassende Mobile-App-Entwicklungsdienste, die hochwertige native und plattformübergreifende Anwendungen liefern. Ich bin spezialisiert auf die Erstellung ansprechender, leistungsstarker mobiler Erlebnisse mit React Native, Flutter und nativen Entwicklungsansätzen für iOS- und Android-Plattformen.",
          metaDescription:
            "Professionelle Mobile-App-Entwicklungsdienste für iOS und Android mit React Native, Flutter und nativen Technologien zur Erstellung ansprechender und leistungsstarker Anwendungen.",
          keywords:
            "Mobile-App-Entwicklung, React Native, Flutter, iOS-Entwicklung, Android-Entwicklung, plattformübergreifende Apps, Mobile UI/UX, App-Leistung",
          features: [
            "Plattformübergreifende Entwicklung",
            "Native iOS- und Android-Entwicklung",
            "Responsives UI-Design",
            "Offline-Funktionalität",
            "Integration von Gerätefunktionen",
            "App-Store-Optimierung",
          ],
          process: [
            "Mobile-App-Strategie und -Planung",
            "UI/UX-Design für Mobile",
            "App-Architekturdesign",
            "Entwicklung und Tests",
            "Leistungsoptimierung",
            "App-Store-Einreichung und -Start",
          ],
        },
        es: {
          title: "Desarrollo de Aplicaciones Móviles",
          shortDescription:
            "Aplicaciones móviles multiplataforma para iOS y Android utilizando React Native y Flutter.",
          description:
            "Servicios completos de desarrollo de aplicaciones móviles que entregan aplicaciones nativas y multiplataforma de alta calidad. Me especializo en crear experiencias móviles atractivas y de alto rendimiento utilizando React Native, Flutter y enfoques de desarrollo nativo para plataformas iOS y Android.",
          metaDescription:
            "Servicios profesionales de desarrollo de aplicaciones móviles para iOS y Android utilizando React Native, Flutter y tecnologías nativas para crear aplicaciones atractivas y de alto rendimiento.",
          keywords:
            "desarrollo de aplicaciones móviles, React Native, Flutter, desarrollo iOS, desarrollo Android, aplicaciones multiplataforma, UI/UX móvil, rendimiento de aplicaciones",
          features: [
            "Desarrollo multiplataforma",
            "Desarrollo nativo para iOS y Android",
            "Diseño de UI responsivo",
            "Funcionalidad sin conexión",
            "Integración de características del dispositivo",
            "Optimización para tiendas de aplicaciones",
          ],
          process: [
            "Estrategia y planificación de aplicaciones móviles",
            "Diseño UI/UX para móviles",
            "Diseño de arquitectura de aplicaciones",
            "Desarrollo y pruebas",
            "Optimización de rendimiento",
            "Envío y lanzamiento en tiendas de aplicaciones",
          ],
        },
      },
    },
    {
      id: "devops",
      icon: "GitBranch",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "DevOps & Cloud",
          shortDescription: "DevOps automation, CI/CD pipelines, and cloud infrastructure setup and management.",
          description:
            "Comprehensive DevOps and cloud infrastructure services that streamline development workflows and optimize application deployment. I specialize in setting up CI/CD pipelines, infrastructure as code, containerization, and cloud-native architectures for reliable and scalable applications.",
          metaDescription:
            "Professional DevOps and cloud infrastructure services including CI/CD pipelines, infrastructure as code, containerization, and cloud-native architectures.",
          keywords:
            "DevOps, CI/CD, cloud infrastructure, Docker, Kubernetes, AWS, Azure, GCP, infrastructure as code, containerization",
          features: [
            "CI/CD pipeline implementation",
            "Infrastructure as Code (IaC)",
            "Container orchestration",
            "Cloud infrastructure setup",
            "Monitoring and logging solutions",
            "Security and compliance automation",
          ],
          process: [
            "DevOps assessment and strategy",
            "Infrastructure architecture design",
            "CI/CD pipeline implementation",
            "Containerization and orchestration",
            "Monitoring and alerting setup",
            "Documentation and knowledge transfer",
          ],
        },
        fr: {
          title: "DevOps & Cloud",
          shortDescription:
            "Automatisation DevOps, pipelines CI/CD et configuration et gestion d'infrastructure cloud.",
          description:
            "Services complets de DevOps et d'infrastructure cloud qui rationalisent les flux de travail de développement et optimisent le déploiement d'applications. Je me spécialise dans la mise en place de pipelines CI/CD, d'infrastructure en tant que code, de conteneurisation et d'architectures cloud-natives pour des applications fiables et évolutives.",
          metaDescription:
            "Services professionnels de DevOps et d'infrastructure cloud comprenant des pipelines CI/CD, de l'infrastructure en tant que code, de la conteneurisation et des architectures cloud-natives.",
          keywords:
            "DevOps, CI/CD, infrastructure cloud, Docker, Kubernetes, AWS, Azure, GCP, infrastructure en tant que code, conteneurisation",
          features: [
            "Implémentation de pipeline CI/CD",
            "Infrastructure en tant que Code (IaC)",
            "Orchestration de conteneurs",
            "Configuration d'infrastructure cloud",
            "Solutions de surveillance et de journalisation",
            "Automatisation de la sécurité et de la conformité",
          ],
          process: [
            "Évaluation et stratégie DevOps",
            "Conception d'architecture d'infrastructure",
            "Implémentation de pipeline CI/CD",
            "Conteneurisation et orchestration",
            "Configuration de surveillance et d'alertes",
            "Documentation et transfert de connaissances",
          ],
        },
        de: {
          title: "DevOps & Cloud",
          shortDescription:
            "DevOps-Automatisierung, CI/CD-Pipelines und Cloud-Infrastruktureinrichtung und -verwaltung.",
          description:
            "Umfassende DevOps- und Cloud-Infrastrukturdienste, die Entwicklungsworkflows optimieren und die Anwendungsbereitstellung verbessern. Ich bin spezialisiert auf die Einrichtung von CI/CD-Pipelines, Infrastructure as Code, Containerisierung und Cloud-native Architekturen für zuverlässige und skalierbare Anwendungen.",
          metaDescription:
            "Professionelle DevOps- und Cloud-Infrastrukturdienste einschließlich CI/CD-Pipelines, Infrastructure as Code, Containerisierung und Cloud-native Architekturen.",
          keywords:
            "DevOps, CI/CD, Cloud-Infrastruktur, Docker, Kubernetes, AWS, Azure, GCP, Infrastructure as Code, Containerisierung",
          features: [
            "CI/CD-Pipeline-Implementierung",
            "Infrastructure as Code (IaC)",
            "Container-Orchestrierung",
            "Cloud-Infrastruktureinrichtung",
            "Überwachungs- und Protokollierungslösungen",
            "Sicherheits- und Compliance-Automatisierung",
          ],
          process: [
            "DevOps-Bewertung und -Strategie",
            "Infrastrukturarchitekturdesign",
            "CI/CD-Pipeline-Implementierung",
            "Containerisierung und Orchestrierung",
            "Einrichtung von Überwachung und Warnmeldungen",
            "Dokumentation und Wissenstransfer",
          ],
        },
        es: {
          title: "DevOps y Cloud",
          shortDescription:
            "Automatización DevOps, pipelines CI/CD y configuración y gestión de infraestructura en la nube.",
          description:
            "Servicios completos de DevOps e infraestructura en la nube que optimizan los flujos de trabajo de desarrollo y optimizan la implementación de aplicaciones. Me especializo en configurar pipelines CI/CD, infraestructura como código, containerización y arquitecturas nativas de la nube para aplicaciones confiables y escalables.",
          metaDescription:
            "Servicios profesionales de DevOps e infraestructura en la nube que incluyen pipelines CI/CD, infraestructura como código, containerización y arquitecturas nativas de la nube.",
          keywords:
            "DevOps, CI/CD, infraestructura en la nube, Docker, Kubernetes, AWS, Azure, GCP, infraestructura como código, containerización",
          features: [
            "Implementación de pipeline CI/CD",
            "Infraestructura como Código (IaC)",
            "Orquestación de contenedores",
            "Configuración de infraestructura en la nube",
            "Soluciones de monitoreo y registro",
            "Automatización de seguridad y cumplimiento",
          ],
          process: [
            "Evaluación y estrategia DevOps",
            "Diseño de arquitectura de infraestructura",
            "Implementación de pipeline CI/CD",
            "Containerización y orquestación",
            "Configuración de monitoreo y alertas",
            "Documentación y transferencia de conocimiento",
          ],
        },
      },
    },
  ],
  enterprise: [
    {
      id: "governance",
      icon: "Shield",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Enterprise AI Governance & Guardrails",
          shortDescription: "Implementation of strict data governance and hallucination mitigation for enterprise LLMs.",
          description: "Implementation of strict data governance and hallucination mitigation for enterprise LLMs. Real-world example: A healthcare AI assistant equipped with semantic routers and deterministic fallbacks that prevent it from dispensing unverified medical advice or leaking PII outside of compliance boundaries (HIPAA/GDPR).",
          metaDescription: "Professional enterprise AI governance services.",
          keywords: "AI governance, hallucination mitigation, semantic routing, AI compliance, LLM security",
          features: [
            "Semantic routing for prompt filtering",
            "PII redaction and compliance pipelines",
            "Deterministic fallback mechanisms",
            "Audit logging for AI decisions",
            "RBAC integration for agent access",
            "Continuous safety monitoring",
          ],
          process: [
            "Compliance requirements gathering",
            "Vulnerability assessment",
            "Guardrail implementation",
            "Red-teaming and testing",
            "Audit pipeline setup",
            "Ongoing policy enforcement",
          ],
        },
      },
    },
    {
      id: "agent-integration",
      icon: "Workflow",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Legacy API-to-Agent Bridging",
          shortDescription: "Connecting autonomous AI agents to existing, complex enterprise systems.",
          description: "Connecting autonomous AI agents to existing, complex enterprise systems (ERPs, CRMs, legacy databases). Real-world example: Connecting a customer support agent directly to a legacy on-premise inventory system via a custom middleware layer, allowing the agent to autonomously check stock levels, initiate refunds, and update Salesforce records without human intervention.",
          metaDescription: "Professional API bridging services for AI agents.",
          keywords: "API bridging, legacy integration, AI agents, CRM integration, enterprise AI",
          features: [
            "Custom middleware development",
            "Authentication and token management",
            "Rate limiting and queueing",
            "Data transformation pipelines",
            "Bidirectional syncing",
            "Failure recovery protocols",
          ],
          process: [
            "API capability audit",
            "Middleware architecture design",
            "Tool definition for agents",
            "Integration and testing",
            "Load testing",
            "Production rollout",
          ],
        },
      },
    },
    {
      id: "transformation",
      icon: "RefreshCw",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Digital Transformation",
          shortDescription: "End-to-end digital transformation strategies and implementation for enterprises.",
          description:
            "Comprehensive digital transformation services that help enterprises modernize their operations, processes, and technology stack. I provide strategic guidance and implementation expertise to help organizations leverage digital technologies for improved efficiency, innovation, and competitive advantage.",
          metaDescription:
            "Professional digital transformation services for enterprises, including strategy development, technology modernization, and process optimization.",
          keywords:
            "digital transformation, enterprise modernization, business process optimization, technology strategy, IT modernization, digital innovation",
          features: [
            "Digital strategy development",
            "Legacy system modernization",
            "Business process optimization",
            "Data-driven decision making",
            "Customer experience enhancement",
            "Organizational change management",
          ],
          process: [
            "Digital maturity assessment",
            "Transformation roadmap development",
            "Technology stack evaluation",
            "Implementation planning",
            "Phased execution and deployment",
            "Continuous improvement and optimization",
          ],
        },
        fr: {
          title: "Transformation Numérique",
          shortDescription:
            "Stratégies et mise en œuvre de transformation numérique de bout en bout pour les entreprises.",
          description:
            "Services complets de transformation numérique qui aident les entreprises à moderniser leurs opérations, processus et stack technologique. Je fournis des conseils stratégiques et une expertise de mise en œuvre pour aider les organisations à tirer parti des technologies numériques pour améliorer l'efficacité, l'innovation et l'avantage concurrentiel.",
          metaDescription:
            "Services professionnels de transformation numérique pour les entreprises, comprenant le développement de stratégie, la modernisation technologique et l'optimisation des processus.",
          keywords:
            "transformation numérique, modernisation d'entreprise, optimisation des processus métier, stratégie technologique, modernisation IT, innovation numérique",
          features: [
            "Développement de stratégie numérique",
            "Modernisation des systèmes existants",
            "Optimisation des processus métier",
            "Prise de décision basée sur les données",
            "Amélioration de l'expérience client",
            "Gestion du changement organisationnel",
          ],
          process: [
            "Évaluation de la maturité numérique",
            "Développement de feuille de route de transformation",
            "Évaluation de la stack technologique",
            "Planification de la mise en œuvre",
            "Exécution et déploiement par phases",
            "Amélioration continue et optimisation",
          ],
        },
        de: {
          title: "Digitale Transformation",
          shortDescription:
            "End-to-End-Strategien und -Implementierung für die digitale Transformation von Unternehmen.",
          description:
            "Umfassende Dienstleistungen zur digitalen Transformation, die Unternehmen bei der Modernisierung ihrer Abläufe, Prozesse und Technologiestacks unterstützen. Ich biete strategische Beratung und Implementierungsexpertise, um Organisationen dabei zu helfen, digitale Technologien für verbesserte Effizienz, Innovation und Wettbewerbsvorteile zu nutzen.",
          metaDescription:
            "Professionelle Dienstleistungen zur digitalen Transformation für Unternehmen, einschließlich Strategieentwicklung, Technologiemodernisierung und Prozessoptimierung.",
          keywords:
            "digitale Transformation, Unternehmensmodernisierung, Geschäftsprozessoptimierung, Technologiestrategie, IT-Modernisierung, digitale Innovation",
          features: [
            "Entwicklung digitaler Strategien",
            "Modernisierung von Legacy-Systemen",
            "Optimierung von Geschäftsprozessen",
            "Datengestützte Entscheidungsfindung",
            "Verbesserung der Kundenerfahrung",
            "Organisatorisches Change-Management",
          ],
          process: [
            "Bewertung der digitalen Reife",
            "Entwicklung einer Transformations-Roadmap",
            "Bewertung des Technologiestacks",
            "Implementierungsplanung",
            "Phasenweise Ausführung und Bereitstellung",
            "Kontinuierliche Verbesserung und Optimierung",
          ],
        },
        es: {
          title: "Transformación Digital",
          shortDescription:
            "Estrategias e implementación de transformación digital de extremo a extremo para empresas.",
          description:
            "Servicios completos de transformación digital que ayudan a las empresas a modernizar sus operaciones, procesos y stack tecnológico. Proporciono orientación estratégica y experiencia en implementación para ayudar a las organizaciones a aprovechar las tecnologías digitales para mejorar la eficiencia, la innovación y la ventaja competitiva.",
          metaDescription:
            "Servicios profesionales de transformación digital para empresas, que incluyen desarrollo de estrategia, modernización tecnológica y optimización de procesos.",
          keywords:
            "transformación digital, modernización empresarial, optimización de procesos de negocio, estrategia tecnológica, modernización de TI, innovación digital",
          features: [
            "Desarrollo de estrategia digital",
            "Modernización de sistemas heredados",
            "Optimización de procesos de negocio",
            "Toma de decisiones basada en datos",
            "Mejora de la experiencia del cliente",
            "Gestión del cambio organizacional",
          ],
          process: [
            "Evaluación de madurez digital",
            "Desarrollo de hoja de ruta de transformación",
            "Evaluación de stack tecnológico",
            "Planificación de implementación",
            "Ejecución e implementación por fases",
            "Mejora continua y optimización",
          ],
        },
      },
    },
    {
      id: "legacy",
      icon: "History",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Legacy System Integration",
          shortDescription: "Integration of modern technologies with legacy systems for enhanced functionality.",
          description:
            "Specialized services for integrating modern technologies with legacy systems to extend their lifespan and enhance their capabilities. I help enterprises bridge the gap between their existing infrastructure and new digital solutions without the need for complete replacement.",
          metaDescription:
            "Expert legacy system integration services to connect existing systems with modern technologies, extending functionality while preserving investments.",
          keywords:
            "legacy system integration, legacy modernization, system integration, API integration, middleware solutions, enterprise integration",
          features: [
            "API development for legacy systems",
            "Middleware implementation",
            "Data migration and synchronization",
            "Hybrid cloud integration",
            "Legacy system extension",
            "Phased modernization approach",
          ],
          process: [
            "Legacy system assessment",
            "Integration architecture design",
            "API and connector development",
            "Testing and validation",
            "Phased implementation",
            "Documentation and knowledge transfer",
          ],
        },
        fr: {
          title: "Intégration de Systèmes Existants",
          shortDescription:
            "Intégration de technologies modernes avec des systèmes existants pour une fonctionnalité améliorée.",
          description:
            "Services spécialisés pour l'intégration de technologies modernes avec des systèmes existants afin de prolonger leur durée de vie et d'améliorer leurs capacités. J'aide les entreprises à combler le fossé entre leur infrastructure existante et les nouvelles solutions numériques sans nécessiter un remplacement complet.",
          metaDescription:
            "Services experts d'intégration de systèmes existants pour connecter les systèmes existants avec des technologies modernes, étendant la fonctionnalité tout en préservant les investissements.",
          keywords:
            "intégration de systèmes existants, modernisation de systèmes existants, intégration de systèmes, intégration d'API, solutions middleware, intégration d'entreprise",
          features: [
            "Développement d'API pour systèmes existants",
            "Implémentation de middleware",
            "Migration et synchronisation de données",
            "Intégration cloud hybride",
            "Extension de systèmes existants",
            "Approche de modernisation par phases",
          ],
          process: [
            "Évaluation des systèmes existants",
            "Conception d'architecture d'intégration",
            "Développement d'API et de connecteurs",
            "Tests et validation",
            "Implémentation par phases",
            "Documentation et transfert de connaissances",
          ],
        },
        de: {
          title: "Integration von Legacy-Systemen",
          shortDescription: "Integration moderner Technologien mit Legacy-Systemen für erweiterte Funktionalität.",
          description:
            "Spezialisierte Dienstleistungen für die Integration moderner Technologien mit Legacy-Systemen, um deren Lebensdauer zu verlängern und ihre Fähigkeiten zu verbessern. Ich helfe Unternehmen, die Lücke zwischen ihrer bestehenden Infrastruktur und neuen digitalen Lösungen zu schließen, ohne dass ein vollständiger Austausch erforderlich ist.",
          metaDescription:
            "Experten-Dienstleistungen zur Integration von Legacy-Systemen, um bestehende Systeme mit modernen Technologien zu verbinden, die Funktionalität zu erweitern und gleichzeitig Investitionen zu schützen.",
          keywords:
            "Legacy-System-Integration, Legacy-Modernisierung, Systemintegration, API-Integration, Middleware-Lösungen, Unternehmensintegration",
          features: [
            "API-Entwicklung für Legacy-Systeme",
            "Middleware-Implementierung",
            "Datenmigration und -synchronisierung",
            "Hybrid-Cloud-Integration",
            "Legacy-System-Erweiterung",
            "Phasenweiser Modernisierungsansatz",
          ],
          process: [
            "Legacy-System-Bewertung",
            "Integrationsarchitekturdesign",
            "API- und Connector-Entwicklung",
            "Tests und Validierung",
            "Phasenweise Implementierung",
            "Dokumentation und Wissenstransfer",
          ],
        },
        es: {
          title: "Integración de Sistemas Heredados",
          shortDescription: "Integración de tecnologías modernas con sistemas heredados para mejorar la funcionalidad.",
          description:
            "Servicios especializados para integrar tecnologías modernas con sistemas heredados para extender su vida útil y mejorar sus capacidades. Ayudo a las empresas a cerrar la brecha entre su infraestructura existente y las nuevas soluciones digitales sin necesidad de un reemplazo completo.",
          metaDescription:
            "Servicios expertos de integración de sistemas heredados para conectar sistemas existentes con tecnologías modernas, extendiendo la funcionalidad mientras se preservan las inversiones.",
          keywords:
            "integración de sistemas heredados, modernización de legado, integración de sistemas, integración de API, soluciones de middleware, integración empresarial",
          features: [
            "Desarrollo de API para sistemas heredados",
            "Implementación de middleware",
            "Migración y sincronización de datos",
            "Integración de nube híbrida",
            "Extensión de sistemas heredados",
            "Enfoque de modernización por fases",
          ],
          process: [
            "Evaluación de sistemas heredados",
            "Diseño de arquitectura de integración",
            "Desarrollo de API y conectores",
            "Pruebas y validación",
            "Implementación por fases",
            "Documentación y transferencia de conocimiento",
          ],
        },
      },
    },
    {
      id: "custom",
      icon: "Package",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Custom Enterprise Solutions",
          shortDescription: "Tailored enterprise solutions for specific business needs and challenges.",
          description:
            "Bespoke enterprise solutions designed and developed to address specific business challenges and requirements. I create custom applications, platforms, and systems that align perfectly with your organization's unique processes, workflows, and objectives.",
          metaDescription:
            "Custom enterprise solution development services tailored to your specific business needs, processes, and objectives.",
          keywords:
            "custom enterprise solutions, bespoke software, enterprise applications, custom business software, tailored IT solutions, enterprise software development",
          features: [
            "Custom application development",
            "Enterprise resource planning",
            "Business process automation",
            "Data management and analytics",
            "Workflow optimization",
            "Integration with existing systems",
          ],
          process: [
            "Business requirements analysis",
            "Solution architecture design",
            "Custom development",
            "Testing and quality assurance",
            "Deployment and integration",
            "Training and ongoing support",
          ],
        },
        fr: {
          title: "Solutions d'Entreprise Personnalisées",
          shortDescription: "Solutions d'entreprise sur mesure pour des besoins et défis commerciaux spécifiques.",
          description:
            "Solutions d'entreprise sur mesure conçues et développées pour répondre à des défis et exigences commerciaux spécifiques. Je crée des applications, plateformes et systèmes personnalisés qui s'alignent parfaitement avec les processus, flux de travail et objectifs uniques de votre organisation.",
          metaDescription:
            "Services de développement de solutions d'entreprise personnalisées adaptées à vos besoins commerciaux, processus et objectifs spécifiques.",
          keywords:
            "solutions d'entreprise personnalisées, logiciels sur mesure, applications d'entreprise, logiciels d'entreprise personnalisés, solutions IT sur mesure, développement de logiciels d'entreprise",
          features: [
            "Développement d'applications personnalisées",
            "Planification des ressources d'entreprise",
            "Automatisation des processus métier",
            "Gestion et analyse de données",
            "Optimisation des flux de travail",
            "Intégration avec les systèmes existants",
          ],
          process: [
            "Analyse des besoins commerciaux",
            "Conception de l'architecture de solution",
            "Développement personnalisé",
            "Tests et assurance qualité",
            "Déploiement et intégration",
            "Formation et support continu",
          ],
        },
        de: {
          title: "Maßgeschneiderte Unternehmenslösungen",
          shortDescription:
            "Maßgeschneiderte Unternehmenslösungen für spezifische Geschäftsanforderungen und Herausforderungen.",
          description:
            "Maßgeschneiderte Unternehmenslösungen, die entwickelt wurden, um spezifische Geschäftsherausforderungen und -anforderungen zu adressieren. Ich erstelle benutzerdefinierte Anwendungen, Plattformen und Systeme, die perfekt auf die einzigartigen Prozesse, Arbeitsabläufe und Ziele Ihrer Organisation abgestimmt sind.",
          metaDescription:
            "Maßgeschneiderte Entwicklungsdienste für Unternehmenslösungen, die auf Ihre spezifischen Geschäftsanforderungen, Prozesse und Ziele zugeschnitten sind.",
          keywords:
            "maßgeschneiderte Unternehmenslösungen, maßgeschneiderte Software, Unternehmensanwendungen, maßgeschneiderte Geschäftssoftware, maßgeschneiderte IT-Lösungen, Unternehmenssoftwareentwicklung",
          features: [
            "Entwicklung maßgeschneiderter Anwendungen",
            "Unternehmensressourcenplanung",
            "Geschäftsprozessautomatisierung",
            "Datenverwaltung und -analyse",
            "Workflow-Optimierung",
            "Integration mit bestehenden Systemen",
          ],
          process: [
            "Analyse der Geschäftsanforderungen",
            "Lösungsarchitekturdesign",
            "Maßgeschneiderte Entwicklung",
            "Tests und Qualitätssicherung",
            "Bereitstellung und Integration",
            "Schulung und laufende Unterstützung",
          ],
        },
        es: {
          title: "Soluciones Empresariales Personalizadas",
          shortDescription: "Soluciones empresariales a medida para necesidades y desafíos comerciales específicos.",
          description:
            "Soluciones empresariales a medida diseñadas y desarrolladas para abordar desafíos y requisitos comerciales específicos. Creo aplicaciones, plataformas y sistemas personalizados que se alinean perfectamente con los procesos, flujos de trabajo y objetivos únicos de su organización.",
          metaDescription:
            "Servicios de desarrollo de soluciones empresariales personalizadas adaptadas a sus necesidades comerciales, procesos y objetivos específicos.",
          keywords:
            "soluciones empresariales personalizadas, software a medida, aplicaciones empresariales, software empresarial personalizado, soluciones de TI a medida, desarrollo de software empresarial",
          features: [
            "Desarrollo de aplicaciones personalizadas",
            "Planificación de recursos empresariales",
            "Automatización de procesos de negocio",
            "Gestión y análisis de datos",
            "Optimización de flujos de trabajo",
            "Integración con sistemas existentes",
          ],
          process: [
            "Análisis de requisitos comerciales",
            "Diseño de arquitectura de solución",
            "Desarrollo personalizado",
            "Pruebas y garantía de calidad",
            "Implementación e integración",
            "Capacitación y soporte continuo",
          ],
        },
      },
    },
    {
      id: "consulting",
      icon: "Lightbulb",
      image: "/placeholder.svg?height=600&width=800",
      translations: {
        en: {
          title: "Architecture Discovery & Strategy",
          shortDescription: "Technical architecture discovery and strategic planning for technology adoption and implementation.",
          description:
            "Expert technology discovery and strategic planning services to help organizations make informed decisions about technology adoption and implementation. I provide hands-on guidance on architecture discovery, system design, implementation strategies, and technical roadmap development.",
          metaDescription:
            "Professional technology discovery and strategic planning services for informed decision-making about technology adoption and implementation.",
          keywords:
            "architecture discovery, IT strategy, digital roadmap, technology selection, system architecture, implementation strategy, technical advisory",
          features: [
            "Technology assessment and selection",
            "Digital strategy development",
            "Architecture design and review",
            "Implementation planning",
            "Vendor selection and management",
            "Technology roadmap development",
          ],
          process: [
            "Current state assessment",
            "Future state visioning",
            "Gap analysis and recommendations",
            "Strategy and roadmap development",
            "Implementation planning",
            "Ongoing advisory and guidance",
          ],
        },
        fr: {
          title: "Conseil & Stratégie",
          shortDescription:
            "Conseil technique et planification stratégique pour l'adoption et l'implémentation de technologies.",
          description:
            "Services experts de conseil technologique et de planification stratégique pour aider les organisations à prendre des décisions éclairées concernant l'adoption et l'implémentation de technologies. Je fournis des conseils sur la sélection de technologies, la conception d'architecture, les stratégies d'implémentation et le développement de feuilles de route numériques.",
          metaDescription:
            "Services professionnels de conseil technologique et de planification stratégique pour une prise de décision éclairée concernant l'adoption et l'implémentation de technologies.",
          keywords:
            "conseil technologique, stratégie IT, feuille de route numérique, sélection de technologies, conseil en architecture, stratégie d'implémentation, conseil en transformation numérique",
          features: [
            "Évaluation et sélection de technologies",
            "Développement de stratégie numérique",
            "Conception et revue d'architecture",
            "Planification d'implémentation",
            "Sélection et gestion de fournisseurs",
            "Développement de feuille de route technologique",
          ],
          process: [
            "Évaluation de l'état actuel",
            "Vision de l'état futur",
            "Analyse des écarts et recommandations",
            "Développement de stratégie et de feuille de route",
            "Planification d'implémentation",
            "Conseil et orientation continus",
          ],
        },
        de: {
          title: "Beratung & Strategie",
          shortDescription:
            "Technische Beratung und strategische Planung für Technologieadoption und -implementierung.",
          description:
            "Experten-Technologieberatung und strategische Planungsdienste, um Organisationen bei informierten Entscheidungen über Technologieadoption und -implementierung zu unterstützen. Ich biete Beratung zur Technologieauswahl, Architekturdesign, Implementierungsstrategien und Entwicklung digitaler Roadmaps.",
          metaDescription:
            "Professionelle Technologieberatung und strategische Planungsdienste für informierte Entscheidungsfindung über Technologieadoption und -implementierung.",
          keywords:
            "Technologieberatung, IT-Strategie, digitale Roadmap, Technologieauswahl, Architekturberatung, Implementierungsstrategie, Beratung zur digitalen Transformation",
          features: [
            "Technologiebewertung und -auswahl",
            "Entwicklung digitaler Strategien",
            "Architekturdesign und -überprüfung",
            "Implementierungsplanung",
            "Anbieterauswahl und -management",
            "Entwicklung technologischer Roadmaps",
          ],
          process: [
            "Bewertung des aktuellen Zustands",
            "Zukunftsvisionen",
            "Lückenanalyse und Empfehlungen",
            "Strategie- und Roadmap-Entwicklung",
            "Implementierungsplanung",
            "Laufende Beratung und Anleitung",
          ],
        },
        es: {
          title: "Consultoría y Estrategia",
          shortDescription:
            "Consultoría técnica y planificación estratégica para la adopción e implementación de tecnología.",
          description:
            "Servicios expertos de consultoría tecnológica y planificación estratégica para ayudar a las organizaciones a tomar decisiones informadas sobre la adopción e implementación de tecnología. Proporciono orientación sobre selección de tecnología, diseño de arquitectura, estrategias de implementación y desarrollo de hojas de ruta digitales.",
          metaDescription:
            "Servicios profesionales de consultoría tecnológica y planificación estratégica para la toma de decisiones informadas sobre la adopción e implementación de tecnología.",
          keywords:
            "consultoría tecnológica, estrategia de TI, hoja de ruta digital, selección de tecnología, consultoría de arquitectura, estrategia de implementación, consultoría de transformación digital",
          features: [
            "Evaluación y selección de tecnología",
            "Desarrollo de estrategia digital",
            "Diseño y revisión de arquitectura",
            "Planificación de implementación",
            "Selección y gestión de proveedores",
            "Desarrollo de hoja de ruta tecnológica",
          ],
          process: [
            "Evaluación del estado actual",
            "Visión del estado futuro",
            "Análisis de brechas y recomendaciones",
            "Desarrollo de estrategia y hoja de ruta",
            "Planificación de implementación",
            "Asesoramiento y orientación continuos",
          ],
        },
      },
    },
  ],
}

// Helper function to get service data by language
export function getServiceData(category: string, language = "en") {
  const categoryData = serviceCategories.find((c) => c.id === category)
  if (!categoryData) return null

  return {
    ...categoryData,
    title:
      categoryData.translations[language as keyof typeof categoryData.translations]?.title ||
      categoryData.translations.en.title,
    description:
      categoryData.translations[language as keyof typeof categoryData.translations]?.description ||
      categoryData.translations.en.description,
    metaDescription:
      categoryData.translations[language as keyof typeof categoryData.translations]?.metaDescription ||
      categoryData.translations.en.metaDescription,
    keywords:
      categoryData.translations[language as keyof typeof categoryData.translations]?.keywords ||
      categoryData.translations.en.keywords,
  }
}

// Helper function to get sub-service data by language
export function getSubServiceData(category: string, subServiceId: string, language = "en") {
  const subServicesForCategory = subServices[category as keyof typeof subServices]
  if (!subServicesForCategory) return null

  const subService = subServicesForCategory.find((s) => s.id === subServiceId)
  if (!subService) return null

  return {
    ...subService,
    title:
      subService.translations[language as keyof typeof subService.translations]?.title ||
      subService.translations.en.title,
    shortDescription:
      subService.translations[language as keyof typeof subService.translations]?.shortDescription ||
      subService.translations.en.shortDescription,
    description:
      subService.translations[language as keyof typeof subService.translations]?.description ||
      subService.translations.en.description,
    metaDescription:
      subService.translations[language as keyof typeof subService.translations]?.metaDescription ||
      subService.translations.en.metaDescription,
    keywords:
      subService.translations[language as keyof typeof subService.translations]?.keywords ||
      subService.translations.en.keywords,
    features:
      subService.translations[language as keyof typeof subService.translations]?.features ||
      subService.translations.en.features,
    process:
      subService.translations[language as keyof typeof subService.translations]?.process ||
      subService.translations.en.process,
  }
}

// Helper function to get all sub-services for a category by language
export function getAllSubServicesForCategory(category: string, language = "en") {
  const subServicesForCategory = subServices[category as keyof typeof subServices]
  if (!subServicesForCategory) return []

  return subServicesForCategory.map((subService) => ({
    ...subService,
    title:
      subService.translations[language as keyof typeof subService.translations]?.title ||
      subService.translations.en.title,
    shortDescription:
      subService.translations[language as keyof typeof subService.translations]?.shortDescription ||
      subService.translations.en.shortDescription,
  }))
}

